export function setBodyOverflow(overflow: "hidden" | "auto") {
  const body = document.body;
  overflow === "hidden" ? body.classList.add("dimmed") : body.classList.remove("dimmed");
}
